// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FloatingControls_FloatingControls__RzduC {
  position: fixed;
  top: 25px;
  right: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/components/FloatingControls/FloatingControls.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb","sourcesContent":[".FloatingControls {\n  position: fixed;\n  top: 25px;\n  right: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FloatingControls": `FloatingControls_FloatingControls__RzduC`
};
export default ___CSS_LOADER_EXPORT___;
